import reviewEventBus from "src/app/eventbus/ReviewEventBus";

export enum ReviewEvent {
    SUBMIT_REVIEW_DECISION = "SUBMIT_REVIEW_DECISION",
    SHOW_REVIEW_CONFIRMATION_DIALOG = "SHOW_REVIEW_CONFIRMATION_DIALOG",
    SHOW_REVIEW_REOPEN_CONFIRMATION_DIALOG = "SHOW_REVIEW_REOPEN_CONFIRMATION_DIALOG",
    CLOSE_REVIEW = "CLOSE_REVIEW",
    SUBMIT_REVIEW = "SUBMIT_REVIEW",
    SHOW_SLP_TICKET_MODAL = "SHOW_SLP_TICKET_MODAL",
    SUBMIT_ODQ_DECISION = "SUBMIT_ODQ_DECISION",
}

export enum ElementType {
    PLAIN_TEXT = 'PLAIN_TEXT',
    HREF = 'HREF',
    IMAGE = 'IMAGE',
    CHECKBOX = 'CHECKBOX',
    RADIO_BUTTON_GROUP = 'RADIO_BUTTON_GROUP',
}

export enum Stage {
    BETA = 'beta',
    GAMMA = 'gamma',
    PROD = 'prod',
}

export enum Region {
    NA = 'na',
    EU = 'eu',
    FE = 'fe',
}

export enum ValueType {
    SINGLE_ITEM = "SINGLE_ITEM",
    MAP = "MAP",
    LIST = "LIST",
    REF = "REF"
}

export enum ReviewResult {
    OFFBOARDED = "OFFBOARDED",
    NO_ACTION = "NO_ACTION",
    RE_OPENED = "RE_OPENED",
    PENDING = 'PENDING',
    RE_INSTATED = "RE_INSTATED",
    NO_RE_INSTATED = "NO_RE_INSTATED",
    INACTIVATED = "INACTIVATED"
}

export enum ReviewStatus {
    PENDING = "PENDING",
    COMPLETED = "COMPLETED"
}

export enum ReviewType {
    PRIMARY_AUDIT = "PRIMARY_AUDIT",
    SECONDARY_AUDIT = "SECONDARY_AUDIT",
    REOPEN_AUDIT = "REOPEN_AUDIT"
    
}

export enum ReferenceType {
    TRANSPORTER = "TRANSPORTER"
}

export enum ReOpenFor {
    RECTIFYING = "RECTIFYING",
    APPEAL = "APPEAL"
}

/**
 * Auditor roles for the Case Audit (Management) page. Role is supplied by MCExecute
 * via the iFrame URL param (?role=). It gates the UI only — the backend independently
 * enforces access via the Midway session (never trusts the URL param).
 * Ref: Case Verifier LLD §9.5.
 */
export enum Role {
    PRIMARY_AUDITOR = "PRIMARY_AUDITOR",
    SECONDARY_AUDITOR = "SECONDARY_AUDITOR",
    QA = "QA",
    MANAGER = "MANAGER",
    UNKNOWN = "UNKNOWN"
}


export enum FieldType {
    TEXT = 'text',
    LINK = 'link',
    RADIO = 'radio',
    DROPDOWN = 'dropdown',
    NUMBER = 'number',
    DATE = 'date',
    TEXTAREA = 'textarea',
    FREEFORM = 'freeform'
}
